import React from 'react';
import { IIconProps } from './utils';

export const Warning = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M6.06601 2.44792C6.91218 0.962673 9.088 0.962675 9.93418 2.44792L15.0494 11.4255C15.8902 12.9021 14.7784 14.6675 13.1148 14.6676H2.88535C1.22167 14.6675 0.110723 12.9022 0.951756 11.4255L6.06601 2.44792ZM8.00058 10.6676C7.41158 10.6678 6.9332 11.145 6.9332 11.734C6.93343 12.3229 7.41173 12.8003 8.00058 12.8005C8.58932 12.8002 9.06676 12.3228 9.06699 11.734C9.06699 11.1451 8.58946 10.6679 8.00058 10.6676ZM8.00058 4.53385C7.55897 4.53398 7.20095 4.89206 7.20078 5.33366V9.06706C7.20101 9.50861 7.559 9.86674 8.00058 9.86686C8.44205 9.8666 8.80016 9.50853 8.80039 9.06706V5.33366C8.80021 4.89214 8.44208 4.53412 8.00058 4.53385Z"
      fill={fill}
    />
  </svg>
);

